import React from 'react'
import { Button, Divider } from 'antd'
import { useTranslation } from 'next-i18next'
import { SendOutlined } from '@ant-design/icons'
import styles from './ProjectTransferButtonsContent.module.scss'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import {
  resetTransferProjectState,
  transferProjectSelector,
  userAuthenticatedState,
  transferProject,
} from 'src/features'

interface PropsType {
  isConfirmValdation: boolean
  handleCancel: () => void
  email: string
  setIsConfirmVisible: () => void
  projectId: number
}

const ProjectTransferButtonsContent: React.FC<PropsType> = (props) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { handleCancel, isConfirmValdation, email, setIsConfirmVisible, projectId } = props
  const userId = useAppSelector(userAuthenticatedState)?.id

  const handleTransfer = () => {
    dispatch(transferProject(userId, projectId, email))
  }

  const { loading } = useAppSelector(transferProjectSelector)

  const goBack = () => {
    dispatch(resetTransferProjectState())
    setIsConfirmVisible()
  }

  return (
    <div>
      <Divider />
      <div className={styles.buttonContent}>
        <Button
          type='default'
          size='large'
          onClick={!isConfirmValdation ? handleCancel : goBack }
          className='mr-4 radius-100'
        >
          {t('Projects.Cancel')}
        </Button>

        {!isConfirmValdation ? (
          <Button
            type='primary'
            htmlType={'submit'}
            size='large'
            className='radius-100'
            icon={<SendOutlined />}
          >
            {t('Projects.Transfer.Title')}
          </Button>
        ): (
          <Button
            type='primary'
            htmlType={'button'}
            size='large'
            className='radius-100'
            loading={loading}
            icon={<SendOutlined />}
            onClick={handleTransfer}
          >
            {loading ? t('Projects.Transfer.MakingTransfer') : t('Projects.Transfer.ConfirmTransfer')}
          </Button>
        )}
      </div>
    </div>
  )
}

export default ProjectTransferButtonsContent
